import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { Web3Provider, Web3Context } from './context/Web3Context';
import Navbar from './components/Navbar/Navbar';
import Notification from './components/Notification/Notification';
import Landing from './pages/Landing/Landing';
import Register from './pages/Register/Register';
import Dashboard from './pages/Dashboard/Dashboard';
import Packages from './pages/Packages/Packages';
import Pools from './pages/Pools/Pools';
import Team from './pages/Team/Team';
import Admin from './pages/Admin/Admin';
import './App.css';

const ProtectedRoute = () => {
  const { account, isRegistered } = useContext(Web3Context);
  if (!account) return <Navigate to="/" replace />;
  if (!isRegistered) return <Navigate to="/register" replace />;
  return <Outlet />;
};

const AdminRoute = () => {
  const { account, isAdmin } = useContext(Web3Context);
  if (!account || !isAdmin) return <Navigate to="/" replace />;
  return <Outlet />;
};

const AppContent = () => {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="app">
        <Navbar />
        <Notification />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/register" element={<Register />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/packages" element={<Packages />} />
              <Route path="/pools" element={<Pools />} />
              <Route path="/team" element={<Team />} />
            </Route>
            <Route element={<AdminRoute />}>
              <Route path="/admin" element={<Admin />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
};

const App = () => {
  return (
    <Web3Provider>
      <AppContent />
    </Web3Provider>
  );
};

export default App;
